/// <amd-module name="DistributedTaskUI/SecurityComponent/ProjectPermissionsAuthorization/Components/ProjectListComponent" />
import * as React from "react";

import * as Resources from "DistributedTaskUI/SecurityComponent/Resources";
import * as ProjectAuthorizationActionsCreator from "ProjectPermissionsAuthorization/Actions/ProjectAuthorizationActionsCreator";
import * as ProjectAuthorizationStore from "ProjectPermissionsAuthorization/Store/ProjectAuthorizationStore";
import { ServiceEndpoint, ServiceEndpointProjectReference } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { ExpandableButton } from "VSSUI/Button";
import { Callout } from "VSSUI/Callout";
import * as Utils_String from "VSS/Core/Util/String";
import { IExpandable } from "VSSUI/Expandable";
import { VssComponent } from "VSS/Platform/Layout";
import { PickList, IPickListSelection, IPickListItem } from "VSSUI/PickList";
import { IOffset, IOrigin, IPoint } from "VSSUI/Utilities/Position";
import { VssIconType } from "VSSUI/VssIcon";
import { Dialog } from "VSSUI/Dialog";
import { TitleSize } from "VSSUI/Header";
import { Observer } from "VSSUI/Observer";
import { ObservableValue } from "VSS/Core/Observable";
import { Link } from "VSSUI/Link";

export interface IProjectListComponentProps {
    item: ProjectAuthorizationStore.IProjectPermissionsSecurityProjectData[];
    endpoint: ServiceEndpoint;
    actionsCreator: ProjectAuthorizationActionsCreator.ProjectAuthorizationActionsCreator;
    canShareProjects: boolean;
}

export class ProjectListComponent extends VssComponent<IProjectListComponentProps> {
    constructor(props: IProjectListComponentProps) {
        super(props);
        this._showDialog = new ObservableValue(false);
    }

    public render(): React.ReactNode {
        return (
            <div>
                <ExpandableButton
                    id="add-project-permission"
                    disabled={!this.props.canShareProjects}
                    renderCallout={this._renderProjectList}
                    iconProps={{
                        iconName: "Add"
                    }}
                    hideDropdownIcon={true}
                    ariaLabel={Resources.AuthorizeProjectTooltip}
                />
                {this._showDialog && this.getDialog()}
            </div>
        );
    }

    private _renderProjectList = (
        dropdown: IExpandable,
        dropdownId: string,
        anchorElement?: HTMLElement,
        anchorOffset?: IOffset,
        anchorOrigin?: IOrigin,
        anchorPoint?: IPoint,
        dropdownOrigin?: IOrigin
    ): JSX.Element => {
        return (
            <Callout
                className="project-permissions-add-dropdown-callout depth-8"
                anchorElement={anchorElement}
                anchorOffset={anchorOffset}
                anchorOrigin={anchorOrigin}
                anchorPoint={anchorPoint}
                calloutOrigin={dropdownOrigin}
                onDismiss={dropdown.collapse}
                escDismiss={true}
                blurDismiss={true}
                lightDismiss={true}
            >
                <PickList
                    className="project-permissions-dropdown"
                    width={256}
                    maxHeight={360}
                    getListItem={this.getPickListItem}
                    ref={(ref) => { if (ref) { ref.focus(); } }}
                    items={this.props.item}
                    isSearchable={true}
                    onSelectionChanged={
                        (selection) => {
                            this.onValueChanged(selection);
                            dropdown.collapse();
                        }
                    }
                    onFocusLost={() => {
                        dropdown.collapse();
                    }}
                    minItemsForSearchBox={0}
                    searchBoxAriaLabel="Search projects"
                />
            </Callout >
        );
    }

    private onValueChanged = (selection: IPickListSelection<ProjectAuthorizationStore.IProjectPermissionsSecurityProjectData>): void => {
        let serviceEndPoint = this.props.endpoint;
        let serviceEndPointName = Utils_String.format("{0}-{1}", serviceEndPoint.name, selection.selectedItems[0].projectName);
        let isprojectReferencePresent = false;
        serviceEndPoint.serviceEndpointProjectReferences.forEach((serviceEndpointProjectReference: ServiceEndpointProjectReference) => {
            if (serviceEndpointProjectReference.projectReference.id === selection.selectedItems[0].projectId) {
                isprojectReferencePresent = true;
            }
        });

        // show the dialog providing information to user about sharing if the user is sharing the service connection for the first time hence the length === 1 check 
        if (serviceEndPoint.serviceEndpointProjectReferences != null && serviceEndPoint.serviceEndpointProjectReferences.length === 1){
            this._showDialog.value = true;
        }

        if (!isprojectReferencePresent) {
            this.setState({ operation: "deletion_event" });
            serviceEndPoint.serviceEndpointProjectReferences = [];
            serviceEndPoint.serviceEndpointProjectReferences.push({ description: serviceEndPoint.description, name: serviceEndPointName, projectReference: ({ id: selection.selectedItems[0].projectId, name: selection.selectedItems[0].projectName }) });
            this.props.actionsCreator.addProjectReference(this.props.endpoint, serviceEndPoint.serviceEndpointProjectReferences);
        }
    }

    private getDialog = (): React.ReactNode => {
        return (
            <Observer isDialogOpen = {this._showDialog}>
                {   
                    (props: { isDialogOpen: boolean }) => {
                        return props.isDialogOpen ? (
                        <Dialog
                            titleProps={{ text: Resources.AddProjectInfoDialogTitle, size: TitleSize.Large }}
                            onDismiss={() => { this._showDialog.value = false; } }
                            footerButtonProps={[
                            { 
                                text: Resources.AddProjectInfoDialogButtonText,
                                primary: true,
                                onClick: () => {
                                    this._showDialog.value = false;
                                } 
                            }
                            ]}
                        >
                    <div>
                        {Resources.AddProjectInfoDialogText} <Link target="_blank" href={Resources.AddProjectInfoDialogLink}>{Resources.AddProjectInfoDialogClickHere}</Link>
                    </div>
                </Dialog>) : null; }
            }
            </Observer>
        );
    }

    private getPickListItem = (item: ProjectAuthorizationStore.IProjectPermissionsSecurityProjectData): IPickListItem => {
        return {
            name: item.projectName,
            key: item.projectId.toString(),
            iconProps: {
                iconType: VssIconType.image,
                imageProps: {
                    src: item.projectImageIconUrl,
                    style: { width: "20px", height: "20px" }
                }
            }
        };
    }

    private _showDialog : ObservableValue<boolean>;
}
